import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Comment, CreateComment } from '../../models';
import { BaseCommentService } from './base-comment.service';

@Injectable({
  providedIn: 'root',
})
export class MockCommentService extends BaseCommentService {
  constructor() {
    super('');
  }

  get(id: string): Observable<Comment[]> {
    return of([]);
  }

  save(model: CreateComment): Observable<any> {
    return of({});
  }

  update(model: Comment): Observable<any> {
    return of({});
  }

  delete(id: string): Observable<any> {
    return of({});
  }
}
